export default __webpack_public_path__ + "static/media/active_qr.d6129114.svg";